<template>
  <GenericList api-endpoint="project" ref="GenericList">
    <template v-slot:title>{{ $t('projectList') }}</template>
    <template v-slot:header>
      <StoreHeader />
    </template>
    <template v-slot:item="{ item, index }">
      <StoreItem :item="item" :index="index" @remove-item="removeItem" />
    </template>
  </GenericList>
</template>

<script>
import StoreHeader from './ProjectHeader.vue';
import StoreItem from './ProjectItem.vue';
import GenericList from '../generic/GenericSearchList.vue';

export default {
  components: {
    StoreHeader,
    StoreItem,
    GenericList,
  },
  methods: {
    removeItem(item) {
      if (this.$refs.GenericList) {
        this.$refs.GenericList.removeItem(item);
      }
    },
    getSearchData() {
      return JSON.stringify({
        sid: this.route.params.id,
      });
    },
  },
};
</script>
